<template>
  <GmapMarker
    v-if="show"
    :position="reservation.sav.position"
    :clickable="false"
    :draggable="false"
    :zIndex="1"
    :icon="icon"
  >
  </GmapMarker>
</template>

<script>
import { mapGetters } from 'vuex'
import { gmapApi } from 'vue2-google-maps'
import iconPath from '@/assets/images/icon-aibus.svg'

export default {
  computed: {
    ...mapGetters({
      status: 'reservation/getStatus',
      reservation: 'reservation/getReserved'
    }),
    google: gmapApi,
    show: function () {
      return this.status == 'RESERVED' && (this.reservation.status == 'PICKING_UP' || this.reservation.status == 'BOARDING')
    },
    icon: function () {
      return {
        url: iconPath,
        scaledSize: new this.google.maps.Size(36, 36)
      }
    }
  }
}
</script>
